import type * as React from 'react';
import { del } from '@Domain/Api';
import organizationLogoRemoved, {
	type OrganizationLogoRemovedAction,
} from '@Application/Branding/OrganizationLogo/Actions/organizationLogoRemoved';
import organizationLogoRemovalFailed, {
	type OrganizationLogoRemovalFailedAction,
} from '@Application/Branding/OrganizationLogo/Actions/organizationLogoRemovalFailed';
import type RemoveOrganizationLogo from '@Application/Branding/OrganizationLogo/Commands/RemoveOrganizationLogo';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = OrganizationLogoRemovedAction | OrganizationLogoRemovalFailedAction;

export default (command: RemoveOrganizationLogo) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(`${parameters.api.host}/api/organizations/${command.organizationId}/logo`);

			const action = organizationLogoRemoved({ organizationId: command.organizationId });
			dispatch(action);
			return action;
		} catch (error) {
			const action = organizationLogoRemovalFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
